import * as Styled from './MHighlightText.styles';
import { AAccentLine, AAccentLineAlignment, AAccentLineSize } from '../../atoms/AAccentLine/index';
import { ASubheader } from '../../atoms/ASubheader/index';
import { ABody, ABodySize } from '../../atoms/ABody/index';
import { MButton } from '../MButton/index';
import { MHighlightTextProps, MHighlightTextAlignment } from './MHighlightText.types';

const COMPONENT_NAME = 'm-web-ui-kit-MHighlightText';
const TEST_ID = 'web-ui-kit-MHighlightText';

export function MHighlightText({
  alignment = MHighlightTextAlignment.Centered,
  showCTA = true,
  aAccentLine = {
    size: AAccentLineSize.OnePx,
    alignment: AAccentLineAlignment.Centered,
  },
  aSubheader,
  aBody,
  mButton,
  hasAccentLine = false,
}: MHighlightTextProps) {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      {hasAccentLine && (
        <AAccentLine
          {...aAccentLine}
          alignment={
            alignment === MHighlightTextAlignment.Left ? AAccentLineAlignment.Left : AAccentLineAlignment.Centered
          }
        />
      )}
      <ASubheader {...aSubheader} />
      {aBody?.bodyText && <ABody {...aBody} size={ABodySize.S} />}
      {showCTA && mButton?.buttonText && <MButton {...mButton} />}
    </Styled.Wrapper>
  );
}

export { MHighlightTextAlignment };
export type { MHighlightTextProps };
